import { useState } from 'react';
import './HelpPanel.css';

const SECTIONS = [
  {
    id: 'start',
    icon: '🚀',
    title: 'PRIMO AVVIO',
    items: [
      {
        q: 'Come configuro la API Key?',
        a: 'Vai su Impostazioni → API KEY GEMINI. Incolla la tua chiave Google AI Studio. Solo l\'admin può inserirla — tutti gli utenti del gruppo la useranno in modo condiviso.',
      },
      {
        q: 'Come aggiungo altri utenti al gruppo?',
        a: 'L\'admin accede a Impostazioni → GESTIONE UTENTI. Da lì può creare nuovi account o approvare richieste di accesso. I nuovi utenti vengono aggiunti automaticamente alla rubrica.',
      },
      {
        q: 'Come cambio la lingua?',
        a: 'Vai su Impostazioni → LINGUA. Puoi scegliere tra: Italiano, English, Español, Français, Deutsch, Português, Nederlands.',
      },
    ],
  },
  {
    id: 'voice',
    icon: '🎤',
    title: 'VOCE & WAKE WORD',
    items: [
      {
        q: 'Come attivo la voce?',
        a: 'Premi l\'orb verde al centro della schermata. Parla chiaramente — l\'AI elaborerà la tua richiesta e risponderà a voce.',
      },
      {
        q: 'Cos\'è "Hey Sirus"?',
        a: 'È la wake word: attiva automaticamente la voce senza toccare lo schermo. Abilita il toggle in alto ("HEY SIRUS"). Funziona solo su browser che supportano il riconoscimento vocale continuo (Chrome/Android consigliato).',
      },
      {
        q: 'Esempi di comandi vocali',
        a: '"Aggiungi compra il latte alla lista" · "Crea task riunione domani alle 10" · "Aggiungi pane alla spesa" · "Qual è il mio prossimo evento?" · "Elimina il task riunione"',
      },
    ],
  },
  {
    id: 'features',
    icon: '▣',
    title: 'FUNZIONALITÀ',
    items: [
      {
        q: '📅 Calendario',
        a: 'Gestisci eventi del gruppo con data e ora. Gli eventi di oggi appaiono in automatico nella barra notifiche. Puoi condividere eventi via WhatsApp o email con il bottone 📤.',
      },
      {
        q: '▣ Task',
        a: 'Lista task condivisa con il gruppo. Seleziona più task con la casella □ per condividerle insieme. Priorità: alta / media / bassa. Segna come done con il tap sulla riga.',
      },
      {
        q: '🛒 Lista Spesa',
        a: 'Lista della spesa condivisa con tutto il gruppo in tempo reale. Aggiungi articoli con quantità. Seleziona più articoli per condividerli insieme via WhatsApp.',
      },
      {
        q: '👤 Rubrica',
        a: 'Contatti del gruppo con nome, telefono ed email. I link tel: e mailto: sono cliccabili direttamente. I nuovi utenti approvati vengono aggiunti in automatico.',
      },
      {
        q: '💬 Group Chat',
        a: 'Invia notifiche in-app ai membri del gruppo. La campanella 🔔 in basso mostra le notifiche in arrivo. Puoi accettare, rifiutare o posticipare.',
      },
    ],
  },
  {
    id: 'sharing',
    icon: '📤',
    title: 'CONDIVISIONE',
    items: [
      {
        q: 'Come condivido via WhatsApp?',
        a: 'Apri un pannello (Calendario, Task o Spesa) → premi il bottone 💬 sulla riga. Si apre WhatsApp con il messaggio precompilato. Per multi-selezione: seleziona più righe con □, poi premi "CONDIVIDI".',
      },
      {
        q: 'Come condivido via Email?',
        a: 'Premi il bottone 📧 sulla riga dell\'evento o task. Si aprirà il client email del tuo dispositivo con il messaggio precompilato. Il mittente è "Sirus Assistant".',
      },
      {
        q: 'Cosa contiene il messaggio condiviso?',
        a: 'Il messaggio include: "👋 sono Sirus Assistant... ho un messaggio per te da [tuo nome]", il contenuto (task / evento / articoli), e una chiusura "Grazie 🥰".',
      },
    ],
  },
  {
    id: 'privacy',
    icon: '🔐',
    title: 'PRIVACY & SICUREZZA',
    items: [
      {
        q: 'Dove vengono salvati i dati?',
        a: 'I dati (task, calendario, spesa, chat) sono salvati solo sul dispositivo (localStorage). Cloudflare KV memorizza solo: credenziali di accesso e API key (cifrate). Nessun tracking, nessuna analytics.',
      },
      {
        q: 'Per quanto tempo si conservano le conversazioni?',
        a: 'La cronologia chat scompare dopo 24 ore. Vengono mantenuti solo gli ultimi 8 messaggi come contesto per l\'AI. Nessuna conversazione viene salvata sul server.',
      },
      {
        q: 'La password è sicura?',
        a: 'Sì. Le password sono hashate con PBKDF2-HMAC-SHA256 (600.000 iterazioni). La API key è cifrata con AES-256-GCM. Dopo 5 tentativi errati, l\'account viene bloccato per 15 minuti.',
      },
    ],
  },
  {
    id: 'faq',
    icon: '❓',
    title: 'FAQ',
    items: [
      {
        q: 'La voce non funziona — cosa faccio?',
        a: 'Assicurati di usare Chrome o un browser basato su Chromium. Controlla che il browser abbia il permesso microfono. Su iOS Safari la voce è limitata — usa Chrome su Android per la migliore esperienza.',
      },
      {
        q: 'L\'AI non risponde o dà errore 401',
        a: 'La sessione è scaduta. Effettua il logout e rientra. Se persiste, l\'admin deve verificare la API key in Impostazioni.',
      },
      {
        q: 'Ho dimenticato la password',
        a: 'Contatta l\'admin del gruppo. L\'admin può resettare il tuo account da GESTIONE UTENTI (elimina e ricrea l\'utente).',
      },
      {
        q: 'Posso usare Sirus offline?',
        a: 'L\'interfaccia carica offline grazie al Service Worker. Ma la risposta AI richiede connessione a internet (chiamata Gemini). Task, spesa e calendario funzionano offline perché sono in localStorage.',
      },
    ],
  },
];

export default function HelpPanel({ onClose }) {
  const [open, setOpen] = useState(null);

  const toggle = (key) => setOpen(p => p === key ? null : key);

  return (
    <div className="help-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="help-box">
        <div className="help-header">
          <span>// HELP & ISTRUZIONI</span>
          <button className="help-close" onClick={onClose}>[X]</button>
        </div>

        <div className="help-version">Sirus Assistant v3.8 — SA-011 Privacy KV — 2026-06-20</div>

        {SECTIONS.map(sec => (
          <div key={sec.id} className="help-section">
            <div className="help-sec-title">{sec.icon} {sec.title}</div>
            {sec.items.map((item, i) => {
              const key = `${sec.id}-${i}`;
              return (
                <div key={key} className="help-item">
                  <div
                    className={`help-q ${open === key ? 'open' : ''}`}
                    onClick={() => toggle(key)}
                  >
                    <span className="help-arrow">{open === key ? '▼' : '▶'}</span>
                    {item.q}
                  </div>
                  {open === key && (
                    <div className="help-a">{item.a}</div>
                  )}
                </div>
              );
            })}
          </div>
        ))}

        <div className="help-footer">
          Per supporto contatta l'admin del gruppo.<br/>
          Sirus Development · UK Registered
        </div>
      </div>
    </div>
  );
}
